import {
  WSFlexBox,
  WSGrid,
  WSIconList,
  WSMarginProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useDefaultCurrency } from "../../../../shared/hooks/useDefaultCurrency";

import styles from "./styles.module.scss";

type Props = WSMarginProps;

export const PayableColumnsStackedView: React.FC<Props> = props => {
  const defaultCurrency = useDefaultCurrency();

  // What a row needs at a glance, not the column names one to one.
  const requiredFields = [
    "Email, external ID or Wingspan ID",
    "Reference key",
    "Engagement",
    "Description",
    `Amount (${defaultCurrency}) or quantity/unit cost`,
    "Due date (or Pay date if paid)"
  ];
  const optionalFields = [
    "Custom fields",
    "Detail and notes",
    "Reimbursable flag",
    "Attachment file id"
  ];

  return (
    <WSGrid gutter="S" {...props}>
      <WSGrid.Item span={{ xs: "12", s: "6" }}>
        <WSFlexBox.CenterY mb="M">
          <WSText.ParagraphSm color="gray500" className={styles.title}>
            Required
          </WSText.ParagraphSm>
        </WSFlexBox.CenterY>
        <WSIconList.Checks
          items={requiredFields}
          iconProps={{
            name: "check-circle",
            color: "green400"
          }}
          textProps={{
            kind: "ParagraphSm"
          }}
          mb="XL"
        />
      </WSGrid.Item>
      <WSGrid.Item span={{ xs: "12", s: "6" }}>
        <WSText.ParagraphSm color="gray500" mb="M">
          Optional
        </WSText.ParagraphSm>
        <WSIconList.Checks
          items={optionalFields}
          iconProps={{
            name: "info-circle",
            color: "gray500"
          }}
          textProps={{
            kind: "ParagraphSm"
          }}
          mb="XL"
        />
      </WSGrid.Item>
    </WSGrid>
  );
};
